// CIO activation flow is too critical,
// so we have to leave a way to show the app even if animation fails.
// P.S. The actual animation duration is about ~3 seconds.
export const EMERGENCY_TIMEOUT = 8000

// Logo animation options
export const LOGO_SIGN_WIDTH = 34
export const LOGO_SIGN_HEIGHT = 32
export const LOGO_SCALE = 3 // for 640x320 video
